//src/components/aols/aeo/OLSupdates/OLS2900/OLS2914.tsx
import React from "react";
import { Layout, Typography, Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import styled from "styled-components";
import { HomeOutlined } from "@ant-design/icons";
import { InlineShareButtons } from "sharethis-reactjs";
import Footer from "../../../../dev/utils/Footer/Footer";
import { updates2900 } from "./OLS2900";

const { Title, Paragraph } = Typography;

const UpdateContainer = styled.div`
  background: #000000;
  min-height: 100vh;
  padding: 40px 20px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const UpdateContent = styled.div`
  max-width: 800px;
  width: 100%;
  background: #1a1a1a;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  text-align: center;
`;

const UpdateTitle = styled(Title)`
  && {
    color: #ffcc00 !important;
    margin-bottom: 20px;
  }
`;

const UpdateParagraph = styled(Paragraph)`
  && {
    color: #fff !important;
    font-size: 16px;
    line-height: 1.8;
    margin-bottom: 24px;
  }
`;

const UpdateLink = styled.a`
  color: #ffaa00 !important;
  text-decoration: none;
  font-size: 16px;
  transition: color 0.3s ease;

  &:hover {
    color: #ffcc00 !important;
    text-decoration: underline;
  }

  &:focus {
    outline: 2px solid #40c4ff;
    outline-offset: 2px;
  }
`;

const HighlightedText = styled.span`
  font-size: 48px;
  color: #ffcc00;
`;

const UpdateImage = styled.img`
  max-width: 100%;
  border-radius: 8px;
  margin: 20px 0;
`;

const BreadcrumbWrapper = styled.div`
  position: absolute;
  top: 10px;
  left: 20px;
  z-index: 1001;

  .ant-breadcrumb a {
    color: #ffcc00;
    transition: color 0.3s ease;
  }

  .ant-breadcrumb a:hover {
    color: #ffaa00;
  }

  @media (max-width: 768px) {
    left: 10px;
    top: 5px;
    .ant-breadcrumb {
      font-size: 12px;
    }
  }
`;

const ShareThisWrapper = styled.div`
  margin-top: 20px;
  padding: 10px;
  background: #1a1a1a;
  border-radius: 8px;
  display: flex;
  justify-content: center;

  .st-btn {
    border: 1px solid #ffcc00 !important;
    border-radius: 4px !important;
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.05);
    }

    &:focus {
      outline: 2px solid #40c4ff;
      outline-offset: 2px;
    }
  }

  .st-total {
    color: #fff !important;
    font-size: 16px;
  }
`;

const OLS2914: React.FC = () => {
  console.log("OLS2914 component rendering - updates2900:", updates2900);
  const update = updates2900.find((u) => u.id === 2914);

  if (!update) {
    console.log("Update 2914 not found in updates2900");
    return null;
  }

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: "OLSLM: 2914.116.3406 - onelightsystem OLS",
    description:
      "Latest OLSLM update for onelightsystem OLS, featuring Sun Light Meditation progress and resources for students and members.",
    url: "https://www.olsme.com/olsupdates/ols2900/2914",
    datePublished: "2025-04-16",
    author: {
      "@type": "Organization",
      name: "onelightsystem OLS",
      url: "https://www.olsme.com",
    },
    publisher: {
      "@type": "Organization",
      name: "onelightsystem OLS",
      url: "https://www.olsme.com",
      logo: "https://www.olsme.com/logo.jpg",
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://www.olsme.com/olsupdates/ols2900/2914",
    },
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.olsme.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "OLS Updates",
          item: "https://www.olsme.com/olsupdates",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "OLS2900",
          item: "https://www.olsme.com/olsupdates/ols2900",
        },
        {
          "@type": "ListItem",
          position: 4,
          name: "OLSLM: 2914.116.3406",
          item: "https://www.olsme.com/olsupdates/ols2900/2914",
        },
      ],
    },
  };

  return (
    <Layout>
      <Helmet>
        <title>OLSLM: 2914.116.3406 - onelightsystem OLS</title>
        <meta
          name="description"
          content="Latest OLSLM update for onelightsystem OLS, featuring Sun Light Meditation progress and resources for students and members."
        />
        <meta
          name="keywords"
          content="OLSLM update, onelightsystem OLS, Sun Light Meditation, OLS updates, Light Civilization, meditation education"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="onelightsystem OLS" />
        <link
          rel="canonical"
          href="https://www.olsme.com/olsupdates/ols2900/2914"
        />
        <meta
          property="og:title"
          content="OLSLM: 2914.116.3406 - onelightsystem OLS"
        />
        <meta
          property="og:description"
          content="Latest OLSLM update for onelightsystem OLS, featuring Sun Light Meditation progress and resources for students and members."
        />
        <meta
          property="og:url"
          content="https://www.olsme.com/olsupdates/ols2900/2914"
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:image"
          content="https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F722.11.116.png?alt=media&token=b7383d98-9fa4-4384-8d3d-d9054b15f403"
        />
        <meta
          property="og:image:alt"
          content="OLSLM Update 2914.116.3406 - Sun Light Meditation"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="onelightsystem OLS" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@onelightsystem" />
        <meta
          name="twitter:title"
          content="OLSLM: 2914.116.3406 - onelightsystem OLS"
        />
        <meta
          name="twitter:description"
          content="Latest OLSLM update for onelightsystem OLS, featuring Sun Light Meditation progress and resources for students and members."
        />
        <meta
          name="twitter:image"
          content="https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F722.11.116.png?alt=media&token=b7383d98-9fa4-4384-8d3d-d9054b15f403"
        />
        <meta
          name="twitter:image:alt"
          content="OLSLM Update 2914.116.3406 - Sun Light Meditation"
        />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <BreadcrumbWrapper>
        <Breadcrumb
          items={[
            {
              title: (
                <Link to="/">
                  <HomeOutlined /> Home
                </Link>
              ),
            },
            {
              title: <Link to="/olsupdates">OLS Updates</Link>,
            },
            {
              title: <Link to="/olsupdates/ols2900">OLS2900</Link>,
            },
            {
              title: "OLSLM: 2914.116.3406",
            },
          ]}
        />
      </BreadcrumbWrapper>

      <UpdateContainer>
        <UpdateContent>
          <UpdateTitle level={1}>OLSLM: 2914.116.3406</UpdateTitle>
          <UpdateParagraph>
            [ 722.11.116.3399, 722.12.116.3399, 1453.1.116.3401, 1453.12.116.3401, 2183.1.116.3403, 2914.116.3406 (OLS student) ]
          </UpdateParagraph>
          <UpdateParagraph>
            <UpdateLink
              href="https://odysee.com/@onelightsystemOLS:f/722.-olsm__11lh-115-2-29:2"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Watch 722.11.116.3399 video on Odysee"
            >
              <HighlightedText>722.11.116.3399</HighlightedText>
            </UpdateLink>
          </UpdateParagraph>
          <UpdateImage
            src="https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F722.11.116.png?alt=media&token=b7383d98-9fa4-4384-8d3d-d9054b15f403"
            alt="OLSLM Update 722.11.116.3399 - Sun Light Meditation Progress"
          />
          <UpdateParagraph>
            <UpdateLink
              href="https://odysee.com/@onelightsystemOLS:f/722.-olsm___12lh-115-2-29:7?r=7Lzv2RSF7jJWdCHdCm1Tnckp8TYcaK6o"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Watch 722.12.116.3399 video on Odysee"
            >
              <HighlightedText>722.12.116.3399</HighlightedText>
            </UpdateLink>
          </UpdateParagraph>
          <UpdateImage
            src="https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F722.12.116.png?alt=media&token=a1ff686b-1670-45ba-aa5c-7173c85aab94"
            alt="OLSLM Update 722.12.116.3399 - Active Meditation Session"
          />
          <UpdateParagraph>
            <UpdateLink
              href="https://odysee.com/@onelightsystemOLS:f/1453.olslm-1lh.-%28active-meditation%29:1?r=7Lzv2RSF7jJWdCHdCm1Tnckp8TYcaK6o"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Watch 1453.1.116.3401 video on Odysee"
            >
              <HighlightedText>1453.1.116.3401</HighlightedText>
            </UpdateLink>
          </UpdateParagraph>
          <UpdateImage
            src="https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F1453.1.116.png?alt=media&token=de2a65be-d9c6-4b07-8fc0-525455945c0f"
            alt="OLSLM Update 1453.1.116.3401 - Sun Light Meditation Progress"
          />
          <UpdateParagraph>
            <UpdateLink
              href="https://odysee.com/@onelightsystemOLS:f/1453.olslm-12lh.-%28active-meditation%29:8?r=7Lzv2RSF7jJWdCHdCm1Tnckp8TYcaK6o"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Watch 1453.12.116.3401 video on Odysee"
            >
              <HighlightedText>1453.12.116.3401</HighlightedText>
            </UpdateLink>
          </UpdateParagraph>
          <UpdateImage
            src="https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F1453.12.116.png?alt=media&token=321f8f96-1cfc-4bdc-803e-c818ef6ee5f3"
            alt="OLSLM Update 1453.12.116.3401 - Active Meditation Session"
          />
          <UpdateParagraph>
            <UpdateLink
              href="https://odysee.com/@onelightsystemOLS:f/2183.OLSLM--1LH--31-116---HD-1080p:c?r=7Lzv2RSF7jJWdCHdCm1Tnckp8TYcaK6o"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Watch 2183.1.116.3403 video on Odysee"
            >
              <HighlightedText>2183.1.116.3403</HighlightedText>
            </UpdateLink>
          </UpdateParagraph>
          <UpdateImage
            src="https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F2183.1.116.png?alt=media&token=10710471-2c56-4423-9aff-843048e65f73"
            alt="OLSLM Update 2183.1.116.3403 - Active Meditation Session"
          />

          <ShareThisWrapper>
            <InlineShareButtons
              config={{
                alignment: "center",
                color: "social",
                enabled: true,
                font_size: 16,
                labels: "cta",
                language: "en",
                networks: [
                  "whatsapp",
                  "linkedin",
                  "messenger",
                  "facebook",
                  "twitter",
                  "blogger",
                  "pinterest",
                  "sms",
                ],
                padding: 12,
                radius: 4,
                show_total: true,
                size: 20,
                min_count: 10,
                url: "https://www.olsme.com/olsupdates/ols2900/2914",
                image:
                  "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F722.11.116.png?alt=media&token=b7383d98-9fa4-4384-8d3d-d9054b15f403",
                description:
                  "Latest OLSLM update for onelightsystem OLS, featuring Sun Light Meditation progress and resources for students and members.",
                title: "OLSLM: 2914.116.3406 - onelightsystem OLS",
                message:
                  "Check out this latest OLSLM update from onelightsystem OLS!",
                subject: "OLSLM Update: 2914.116.3406",
                username: "onelightsystem",
              }}
            />
          </ShareThisWrapper>
        </UpdateContent>
      </UpdateContainer>

      <Footer />
    </Layout>
  );
};

export default OLS2914;